import {
  createBlogApi,
  deleteBlogApi,
  getBlogByIdApi,
  getBlogsApi,
  updateBlogApi,
} from "helpers/backend_helper";
import {
  createBlogFailure,
  createBlogSuccess,
  deleteBlogError,
  deleteBlogSuccess,
  getBlogByIdError,
  getBlogByIdSuccess,
  getBlogsError,
  getBlogsSuccess,
  setIsLoading,
  setPagination,
  updateBlogError,
  updateBlogSuccess,
} from "./reducer";
import { Action, Dispatch, ThunkAction } from "@reduxjs/toolkit";
import { getJewelleriesError } from "slices/jewellery/reducer";
import { RootState } from "slices";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const mockApiCreateBlog = (blogData: any) =>
  new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(blogData);
    }, 2000);
  });

export const createBlog =
  (body: any, navigate: any) => async (dispatch: Dispatch) => {
    try {
      // const response: any = await mockApiCreateBlog(blogData);
      dispatch(setIsLoading(true));
      const response: any = await createBlogApi(body);
      toast.success("Blog created Successfully!", { autoClose: 2000 });
      // localStorage.setItem("blogs", JSON.stringify(response));
      navigate("/blogs");
      dispatch(createBlogSuccess(response.data));
      return response;
    } catch (error) {
      dispatch(createBlogFailure("Error while creating blog"));
      toast.error("Blog created Failed!", { autoClose: 2000 });
      // dispatch(setIsLoading(false));
    } finally {
      dispatch(setIsLoading(false)); // End loading
    }
  };

export const getBlogs =
  (body: any): ThunkAction<void, RootState, unknown, Action<string>> =>
  async (dispatch: Dispatch) => {
    try {
      dispatch(setIsLoading(true));
      const response: any = await getBlogsApi(body);
      // const response: any = await getBlogsApi(body);
      // dispatch(setIsLoading(false));
      dispatch(setPagination(response.data.pagination));
      dispatch(getBlogsSuccess(response.data));
    } catch (error: any) {
      // dispatch(setIsLoading(false));
      dispatch(getBlogsError(error));
    } finally {
      dispatch(setIsLoading(false)); // End loading
    }
  };

export const getBlogById =
  (id: string): ThunkAction<void, RootState, unknown, Action<string>> =>
  async (dispatch: Dispatch) => {
    try {
      dispatch(setIsLoading(true));
      const response: any = await getBlogByIdApi(id);
      dispatch(getBlogByIdSuccess(response.data));
      return response;
    } catch (error: any) {
      dispatch(getBlogByIdError(error));
    } finally {
      dispatch(setIsLoading(false)); // End loading
    }
  };

export const updateBlog =
  (id: string, body: any, navigate: any) => async (dispatch: Dispatch) => {
    try {
      dispatch(setIsLoading(true));
      const response: any = await updateBlogApi(id, body);
      navigate("/blogs");
      dispatch(updateBlogSuccess(response.data));
      toast.success("Blog updated Successfully!", { autoClose: 2000 });
      return response;
    } catch (error: any) {
      dispatch(updateBlogError(error));
      toast.error("Blog updated Failed!", { autoClose: 2000 });
    } finally {
      dispatch(setIsLoading(false)); // End loading
    }
  };

export const deleteBlog = (id: string) => async (dispatch: Dispatch) => {
  try {
    dispatch(setIsLoading(true));
    await deleteBlogApi(id);
    dispatch(setIsLoading(false));
    dispatch(deleteBlogSuccess(id as any));
    toast.success("Jewellery deleted Successfully", { autoClose: 2000 });
  } catch (error: any) {
    dispatch(setIsLoading(false));
    dispatch(deleteBlogError(error));
    toast.error("Jewellery deleted Failed", { autoClose: 2000 });
  }
};
